<app-navbar [title]="pageTitle">
	<a routerLink="../../" class="btn btn-success me-4" (click)="save()" [fragment]="scrollToId">
		<i class="fas fa-check"></i> Zapisz
	</a>
	<a routerLink="../../" class="btn btn-danger" [fragment]="scrollToId"> <i class="fas fa-times"></i> Anuluj </a>
</app-navbar>

<table class="table table-striped table-hover">
	<thead>
		<tr>
			<th>Kwota</th>
			<th>Ilosc</th>
			<th>Rodzaj operacji</th>
			<th>Uwagi</th>
			<th>Wydarzenie</th>
			<th></th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of positions">
			<td>
				<div class="input-group mb-3">
					<input type="number" step="0.01" class="form-control" name="value" [(ngModel)]="item.value" />
					<span class="input-group-text">{{ data.currency }}</span>
				</div>
			</td>
			<td>
				<input type="number" class="form-control" name="quantity" [(ngModel)]="item.quantity" />
			</td>
			<td>
				<select class="form-select" name="type" [id]="item.id" [(ngModel)]="item.type">
					<option value="">(brak)</option>
					<option value="{{ opt.id }}" *ngFor="let opt of types">{{ opt.name }}</option>
				</select>
			</td>
			<td>
				<input type="text" class="form-control" name="comment" [(ngModel)]="item.comment" />
			</td>
			<td>
				<mat-form-field appearance="outline" class="w-100">
					<input
						matInput
						type="text"
						[formControl]="getTourismEventControl(item.id)"
						[matAutocomplete]="autoEvent"
						placeholder="Wpisz nazwę (min. 3 znaki)"
					/>
					<mat-autocomplete
						#autoEvent="matAutocomplete"
						[displayWith]="displayTourismEventFn.bind(this)"
						(optionSelected)="onTourismEventSelected($event, item)"
					>
						@for (event of getFilteredTourismEvents(item.id); track event.id) {
							<mat-option [value]="event">
								{{ event.name }}{{ event.date_from ? ' (' + event.date_from + ')' : '' }}
							</mat-option>
						}
					</mat-autocomplete>
				</mat-form-field>
				@if (!item.linkEvents && item.tourismEventIdName) {
					<small class="text-muted">{{ item.tourismEventIdName }}</small>
				}
			</td>
			<td class="text-center">
				<button class="btn btn-danger" (click)="deleteAsk(item)">Usuń</button>
			</td>
		</tr>
	</tbody>
</table>
<div class="d-grid">
	<button class="btn btn-primary" type="button" (click)="addPosition()">
		<i class="fas fa-plus"></i>
		Dodaj pozycję
	</button>
</div>
